import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { SubscriptionForm } from './SubscriptionForm';

// Make sure to use the publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

interface StripeWrapperProps {
  planId: string;
  planName: string;
  planPrice: number;
}

const StripeWrapper: React.FC<StripeWrapperProps> = ({ planId, planName, planPrice }) => {
  return (
    <Elements stripe={stripePromise}>
      <SubscriptionForm 
        planId={planId} 
        planName={planName} 
        planPrice={planPrice} 
      />
    </Elements>
  );
};

export default StripeWrapper; 